import React, { useState } from "react";

import CustomLink from "../components/custom-link";

import CategoryItems from "../components/category-items";
import CategoryPill from "../components/category-pill";
import MenuData from "../data/data";
import "../styles/menu.scss";

const Menu = ({ category, setCategory }) => {
  // const [category, setCategory] = useState("Veg Starters");
  const [reviewIndex, setReviewIndex] = useState(0);
  const categoryOnClickHandler = (categoryItem) => {
    setCategory(categoryItem);
  };
  return (
    <div className="menu-page">
      <div className="main-content">
        <div className="hero-banner">
          <div className="hero-banner__content">
            <div className="banner-text">ENJOY YOUR DELICIOUS MEAL</div>
            <h1 className="banner-title">Hyderabad Biryani</h1>
            <div className="banner-description">
              <p>
                Biryani is an Indian Dish. With a layer of meat at the botton
                mixed with spices and rice covered on the top.
              </p>
            </div>
            {/* <button className="hero-banner_btn">Explore Now</button> */}
            {/* <Button btnText="Explor Now" styleName="hero-banner_btn" /> */}
            <div className="hero-banner__btn__container">
              <a href="#menu-container" className="hero-banner_btn">
                Explore Now
              </a>
            </div>
          </div>
        </div>
        <div className="menu-container" id="menu-container">
          <div className="menu-selection-header">
            <div className="menu-selection__title">Select From Our Menu</div>
            <h2 className="menu-selection__tag">
              Signature <span>Dishes</span>
            </h2>
          </div>
          <div className="menu-container__content">
            <ul className="menu-container__categories">
              {Object.keys(MenuData.menu).map((item, index) => (
                <CategoryPill
                  key={index}
                  category={item}
                  activeCategory={category}
                  categoryOnClick={categoryOnClickHandler}
                />
              ))}
            </ul>
            <div className="menu-container__items">
              <CategoryItems
                items={MenuData.menu[category]}
                title={category}
                data={MenuData.menu}
              />
            </div>
          </div>
        </div>
        <div className="menu__customer-reviews-overlay">
          <div className="menu__review-gallery-container">
            <div className="menu__customer-reviews-container">
              <div className="menu__customer-reviews">
                <div className="menu__customer-review-title">
                  <div className="menu__customer-review-tag">Reviews</div>
                  <h2 className="menu__customer-review-heading">
                    Happy <span>Customers</span>
                  </h2>
                </div>
                <div className="menu__customer-review">
                  {MenuData.reviews[reviewIndex].imageUrl && (
                    <div className="menu__customer-review-image-container">
                      <img
                        className="menu__customer-review-image"
                        src={MenuData.reviews[reviewIndex].imageUrl}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="menu__customer-review-text">
                    <p>{MenuData.reviews[reviewIndex].review}</p>
                  </div>
                  <div className="menu__customer-name">
                    <span>-by</span>
                    {MenuData.reviews[reviewIndex].reviewerName}
                  </div>
                </div>
                <div className="menu__customer-review-dots-container">
                  {MenuData.reviews.map((review, index) => (
                    <span
                      className={
                        index === reviewIndex
                          ? "menu__customer-review-dots active"
                          : "menu__customer-review-dots"
                      }
                      key={index}
                      onClick={() => {
                        setReviewIndex(index);
                      }}
                    ></span>
                  ))}
                </div>
              </div>
            </div>
            <div className="menu__gallery-container">
              <div className="menu__gallery-tag">GALLERY</div>
              <h2 className="menu__gallery-title">
                Our <span>Dishes</span>
              </h2>
              <div className="menu__gallery-image-container">
                <div className="menu__gallery-image">
                  <img
                    src={require("../assets/images/gulabjamun-gallery.jpg")}
                    alt="gallery dish image"
                  />
                </div>
                <div className="menu__gallery-image">
                  <img
                    src={require("../assets/images/biryani-background(copy).jpg")}
                    alt="gallery dish image"
                  />
                </div>
                <div className="menu__gallery-image">
                  <img
                    src={require("../assets/images/samosa-gallery.jpg")}
                    alt="gallery dish image"
                  />
                </div>
                <div className="menu__gallery-image">
                  <img
                    src={require("../assets/images/Qubani-ka-meeta-gallery.jpg")}
                    alt="gallery dish image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="menu__party-orders-container">
          <div className="menu__party-orders-header">
            <div className="menu__party-orders-tag">Events</div>
            <h2 className="menu__party-orders-title">
              Party <span>Orders</span>
            </h2>
            <div className="menu__party-orders-description">
              <p>
                We cater for party's, let us know about your event and we got
                you covered with wide variety of dishes to choose from. You can
                choose what best suits your needs and let us know atleast a day
                before.
              </p>
            </div>
          </div>
          <div className="menu__party-orders-content">
            <div className="menu__party-orders-img-container">
              <img src={require("../assets/images/party-order.jpg")} alt="" />
            </div>
            <div className="menu__party-orders-item-content">
              <div className="menu__party-orders-item">
                <div className="menu__party-orders-item-price">
                  {" "}
                  Starting at $50.00
                </div>
                <div className="menu__party-orders-item-name">
                  Our Party tray's
                </div>
              </div>
              <div className="menu__party-orders-item-description">
                <p>
                  We have wide variety of catering available for your party's.
                  We have a menu for every event whether it be a Birthday,
                  Special Event or Puja. You can choose your favourite menu that
                  best suits your event.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="menu__customer-reviews-overlay menu__order-now">
          <div className="menu__place-order-container">
            {/* <div className="menu__place-order-tag">Order</div> */}
            <div className="menu__place-order-title">Place Your Order Now</div>
            <div className="menu__place-order-description">
              <p>
                Enjoy the meal of the day by placing your order now. Hit the
                button below to choose the dishes and Place your order.
              </p>
            </div>
            <div className="order-now-btn-container">
              <div className="order-now_btn">
                <CustomLink to="/error">Order Now</CustomLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
